import React, { useState } from "react";
import "./EmpReg.css";
import axios from "axios";
import EmployeeForm from "./EmpRegForm.jsx";

function Employee() {
  const [table, setTable] = useState(true);
  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState({});
  const [addFormGender, setAddFormGender] = useState("");
  const handleEmployeeSubmit = (event) => {
    event.preventDefault();
    // console.log("id", event.target[0].value, event.target[1].value);

    let body = {
      Email: event.target[0].value,
      Password: event.target[1].value,
      Account: event.target[2].value,
      RoleID: event.target[3].value,
      Gender: addFormGender,
      FirstName: event.target[6].value,
      MiddleName: event.target[7].value,
      LastName: event.target[8].value,
      DOB: event.target[9].value,
      ContactNo: event.target[10].value,
      EmployeeCode: event.target[11].value,
      DepartmentID: event.target[12].value,
      PositionID: event.target[13].value,
      DateOfJoining: event.target[14].value,
      TerminateDate: event.target[15].value,
    };
    axios
      .post(
        "https://almawridems.javedahmadghamidi.com/api/ems/employeenew",
        body,
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((res) => {
        alert("Thankyou for Registration, Now you can login");
        setTable(false);
        setTable(true);
        window.location.href = "https://ems.al-mawrid.org/login";
      })
      .catch((err) => {
        alert("Registration Failed, Contact Admin/HR");
        console.log(err);
      });
  };
  const handleFormClose = () => {
    setTable(true);
  };
  const handleAddFormGenderChange = (e) => {
    // console.log(e.currentTarget.value);
    setAddFormGender(e.currentTarget.value);
  };

  return (
    <div
      style={{
        backgroundColor: "white",
        paddingTop: "50px",
        paddingBottom: "50px",
      }}>
      {table && (
        <EmployeeForm
          onEmployeeSubmit={handleEmployeeSubmit}
          onFormClose={handleFormClose}
          onGenderChange={handleAddFormGenderChange}
        />
      )}
    </div>
  );
}

export default Employee;
